import {ModelGroup} from '../../model-group/model-group.model';

export class Model {
  id: number;
  model: string;
  modelNumber: string;
  fuel: string;
  cylinder: number;
  modelGroup: ModelGroup;
}
